var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6458 19.0487H12.787C12.1949 19.0487 11.7151 18.5689 11.7151 17.9768V14.118C11.7151 13.6443 11.3313 13.2605 10.8576 13.2605H9.14255C8.66877 13.2605 8.28504 13.6443 8.28504 14.118V17.9768C8.28504 18.5689 7.80526 19.0487 7.21315 19.0487H3.35436C2.76225 19.0487 2.28247 18.5689 2.28247 17.9768V9.79318C2.28247 8.80747 2.73438 7.87621 3.50828 7.26653L9.60174 2.4649C9.83541 2.28139 10.1647 2.28139 10.3979 2.4649L16.4923 7.26653C17.2662 7.87621 17.7176 8.80704 17.7176 9.79232V17.9768C17.7176 18.5689 17.2379 19.0487 16.6458 19.0487Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.b73d9b6e.svg";
export { ForwardRef as ReactComponent };